import React from "react";
import { Link } from "react-router-dom";

import { Ripple } from "primereact/ripple";
import { Slide, Fade } from 'react-awesome-reveal';

import { playStoreLink, appStoreLink } from "../../Utils/Info";
interface DownloadAppProps {
    downloadAppRef?: React.RefObject<HTMLDivElement>;
}

const DownloadApp: React.FC<DownloadAppProps> = ({ downloadAppRef }) => {
    return (
        <section className="download_app_section" id="download_app_section" ref={downloadAppRef}>
            <div className="section__padding pt-0">
                <article className="download_app_container section__padding">
                    <div className="container-md">
                        <div className="download_app_content">
                            <Slide direction="up" triggerOnce>
                                <h3 className="download_app_head">Download <br /> the App</h3>
                            </Slide>
                            <Slide direction="up" delay={50} triggerOnce>
                                <p className="download_app_desc">
                                    Download the Traqdo app today from the Play Store or App Store and manage your projects on the go. Stay organized, track progress, and collaborate with your team anytime, anywhere.
                                </p>
                            </Slide>
                            <Slide direction="up" delay={100} triggerOnce>
                                <div className="home_hero_app_section download_app_links">
                                    <Link target="_blank" to={appStoreLink} className="mb_app_link p-ripple">
                                        <img src="/assets/images/website/home-page/app_store.svg" alt="App Store" loading="lazy" />
                                        <Ripple />
                                    </Link>
                                    <Link target="_blank" to={playStoreLink} className="mb_app_link p-ripple">
                                        <img src="/assets/images/website/home-page/play_store.svg" alt="Play Store" loading="lazy" />
                                        <Ripple />
                                    </Link>
                                </div>
                            </Slide>
                        </div>
                    </div>

                    <Fade delay={100} triggerOnce>
                        <img src="/assets/images/website/home-page/download_app.webp" loading="lazy" className="download_app_img" alt="Download Traqdo App" />
                    </Fade>
                </article>
            </div>
        </section>
    )
}

export default DownloadApp;